export class CorrectionItem {
    correct: boolean;
    item?: string;
    details: string;
    picked: boolean;

    constructor(
        correct: boolean,
        details: string,
        picked: boolean,
        item?: string
    ) {
        this.correct = correct;
        this.details = details;
        this.picked = picked;
        this.item = item;
    }
}
